module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-key"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("2012 English bluebell survey (Hyacinthoides non-scripta)")]), _vm._v(" "), _c('p', {
    staticClass: "icon under100"
  }, [_vm._v("dominant: 80 -100%")]), _vm._v(" "), _c('p', {
    staticClass: "icon under80"
  }, [_vm._v("abundant: 60 - 80% ")]), _vm._v(" "), _c('p', {
    staticClass: "icon under60"
  }, [_vm._v("frequent: 40 -60%")]), _vm._v(" "), _c('p', {
    staticClass: "icon under40"
  }, [_vm._v("occasional: 20 - 40%")]), _vm._v(" "), _c('p', {
    staticClass: "icon under20"
  }, [_vm._v("rare: 1 - 20%")]), _vm._v(" "), _c('p', {
    staticClass: "icon none"
  }, [_vm._v("not surveyed")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48c9e322"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/keys/BluebellKey.vue
// module id = 98
// module chunks = 1